import { gsap } from "gsap";
import Alpine from "alpinejs";

Alpine.data("image", () => ({
  init() {
    // console.log('image init')
  },
  destroy() {
    // console.log('image destroy')
  }
}));